var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonOutline = function SvgPersonOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.425a1.575 1.575 0 1 1 0 3.15 1.575 1.575 0 0 1 0-3.15m0 6.75c2.227 0 4.575 1.095 4.575 1.575v.825h-9.15V9.75c0-.48 2.348-1.575 4.575-1.575M6 0a3 3 0 1 0 0 6 3 3 0 1 0 0-6m0 6.75c-2.002 0-6 1.005-6 3V12h12V9.75c0-1.995-3.998-3-6-3"
  })));
};
export default SvgPersonOutline;